import { render } from "./Collect.vue?vue&type=template&id=517f3b26&scoped=true"
import script from "./Collect.vue?vue&type=script&lang=js"
export * from "./Collect.vue?vue&type=script&lang=js"

import "./Collect.vue?vue&type=style&index=0&id=517f3b26&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20241218.110742/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517f3b26"]])

export default __exports__